
import AnimatedPage from "./animatedPage"
import { DecodeHtml } from "../utils/decodeHtml"
import { retrunAssets } from "../utils/getAssets"
import useFetch from "../utils/useFetch"
import Banner from "./banner/banner"

const MarkupPage = ({ url }) => {

    const state = useFetch(url)
    const data = state?.properties
    const title = data?.title
    const bg = data?.backgroundImage != null ? retrunAssets(data?.backgroundImage[0]?.url) : ""




    return (
        <AnimatedPage>
            <Banner text={title} bg={bg} />
            <div className="flex items-center justify-center p-8 md:px-12 ">
                <div className="w-full flex justify-center  lg:max-w-7xl">
                    <p className=" whitespace-pre-line font-normal">{DecodeHtml({ html: data?.contents?.markup })}</p>
                </div>
            </div>
        </AnimatedPage>
    )
}

export default MarkupPage